import { GoabTemporaryNotificationCtrl } from "@abgov/react-components";

const ToastNotifications = () => {
  return (
    <GoabTemporaryNotificationCtrl
      verticalPosition="top"
      horizontalPosition="right"
    />
  );
};

export default ToastNotifications;